export const transcriptionSidebarActions = {};
